import axios from "axios";
const BASE_URL = process.env.REACT_APP_DEV_URL;

export const createOrder = async (token, data, retailerId) => {
  const url = `${BASE_URL}/order/retailer_id/${retailerId}/`;
// console.log(token, data, retailerId);

const config = {
  headers: {
    Authorization: `Token ${token}`,
  },
};

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Unauthorized Access.", error.response);
      return error.response;
    } else {
      console.error(error);
      throw error;
    }
  }
};

export const getAllOrders = async (token, params = {}) => {
  const url = `${BASE_URL}/order/order_details/`;
  // console.log(token, params);
  

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
    params,
  };

  try {
    const response = await axios.get(url, config);
    
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Unauthorized Access.", error.response);
      return error.response;
    } else {
      console.error(error);
      throw error;
    }
  }
};

export const getOrder = async (token, orderId) => {
  const url = `${BASE_URL}/order/order_details/${orderId}/`;

  // console.log(url);
  

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const updateOrderStatus = async (token, data, orderId) => {
  const url = `${BASE_URL}/order/order_id/${orderId}/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.put(url, data, config);
    return response;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const updateOrder = async (token, orderId, params = {}) => {
  // Construct the URL manually to avoid automatic encoding
  const queryString = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  const url = `${BASE_URL}/order/order_id/${orderId}/?${queryString}`;

  console.log("Constructed URL:", url);

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.put(url, {}, config);
    // console.log("Response:", response);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Unauthorized Access.", error.response);
      return error.response;
    } else {
      console.error("Error:", error);
      throw error;
    }
  }
};

export const deleteProduct = async (token, itemId) => {
  const url = `${BASE_URL}/order/delete_item/${itemId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.error("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const applyCoupon = async (token, data) => {
  const url = `${BASE_URL}/order/coupon_apply/`;
// console.log(token, data);

const config = {
  headers: {
    Authorization: `Token ${token}`,
  },
};

  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Unauthorized Access.", error.response);
      return error.response;
    } else {
      console.error(error);
      throw error;
    }
  }
};

export const increaseByTen = async (token, data, retailerId) => {
  const url = `${BASE_URL}/carts/increased_by_ten/${retailerId}/`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.put(url, data, config);
    return response;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};


